import { dayjs } from "@/lib/dayjs";

export const getTime = (
  month: number,
): {
  start: string;
  end: string;
} => {
  const currentMonth = dayjs().month();

  if (month === currentMonth) {
    return {
      start: dayjs().startOf("month").format("DD-MM-YYYY"),
      end: dayjs().endOf("month").format("DD-MM-YYYY"),
    };
  }

  if (month < currentMonth) {
    return {
      start: dayjs().startOf("year").add(1, "year").add(month, "month").format("DD-MM-YYYY"),
      end: dayjs().startOf("year").add(1, "year").add(month, "month").endOf("month").format("DD-MM-YYYY"),
    };
  }

  return {
    start: dayjs().startOf("year").add(month, "month").format("DD-MM-YYYY"),
    end: dayjs().startOf("year").add(month, "month").endOf("month").format("DD-MM-YYYY"),
  };
};
